/**
 * @description 시간은 24시간형식 - HH만 사용한다.
 * yyyy , YYYY - 년도
 * MM, M - 2자리 또는 1자리 월
 * DD, D - 2자리 또는 1자리 일
 * HH, H - 2자리 또는 1자리 시간
 * mm, m - 2자리 또는 1자리 분
 * ss, s - 2자리 또는 1자리 초
 * dddd - 월요일,화요일
 * ddd - 월, 화
 */

export const dateFormatter = (date: Date, format = 'YYYY-MM-DD HH:mm'): string => {
    if (!date) {
        return '';
    }
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString();
    const seconds = date.getSeconds().toString();
    const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)

    const daysOfWeek = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
    const shortsDaysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];

    format = format.replace(/YYYY/g, year);
    format = format.replace(/yyyy/g, year);
    format = format.replace(/MM/g, month.padStart(2, '0')); // 'MM' -> '07', 'M' -> '7'
    format = format.replace(/M/g, month);
    format = format.replace(/DD/g, day.padStart(2, '0'));
    format = format.replace(/D/g, day);
    format = format.replace(/HH/g, hours.padStart(2, '0'));
    format = format.replace(/H/g, hours);
    format = format.replace(/mm/g, minutes.padStart(2, '0'));
    format = format.replace(/m/g, minutes);
    format = format.replace(/ss/g, seconds.padStart(2, '0'));
    format = format.replace(/s/g, seconds);
    format = format.replace(/ddd/g, shortsDaysOfWeek[dayOfWeek]);
    format = format.replace(/dddd/g, daysOfWeek[dayOfWeek]);

    return format;
};
